module.exports = __webpack_public_path__ + "static/calendars-not-shown-header-ce1433bc3438ea366288823940e391e9.png";